import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var UnauthorizedError = function UnauthorizedError() {
    _classCallCheck(this, UnauthorizedError);
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/unauthorized.js
// module id = ./src/abstractions/errors/unauthorized.js
// module chunks = 34